import React from 'react';

const ButtonRound = props => (
    <div style={props.style} className={props.className}>
        <a href='/#' onClick={e=> {
            e.preventDefault();
            if(props.enabled || props.light){
                props.onClick();
            }
        }}>
            {props.children}
        </a>
        <style>{`
            a {
                background: ${props.light ? '#fff' : (props.enabled ? '#004586' : 'rgb(197, 213, 228)')};
                text-align: center;
                border-radius: 50px !important;
                color: ${props.light ? '#004586' : '#fff'};
                text-transform: uppercase;
                display: block;
                padding: 20px;
                font-size: 16px;
            }
        `}
        </style>
    </div>
);

export default ButtonRound;